import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiFetch } from '../../../utilities/appFetch';
import locationRoutes from '../../../components/location/locationRoutes';

const update = createAsyncThunk(
  'thunk/location/delete',
  async (arg, thunkAPI) => {
    const response = await apiFetch(locationRoutes.api.generate.delete(arg?.id), {
      method: 'DELETE',
    });
    if (!response?.success) {
      return thunkAPI.rejectWithValue(response);
    }
    return response.result;
  },
);

export default update;
